import { AnalyticsBrowser } from '@segment/analytics-next';

export interface SegmentAbstraction {
  segmentInstance?: AnalyticsBrowser;
  page(...args: Parameters<AnalyticsBrowser['page']>): Promise<void>;
  track(...args: Parameters<AnalyticsBrowser['track']>): Promise<void>;
  identify(...args: Parameters<AnalyticsBrowser['identify']>): Promise<void>;
}

export class SegmentLive implements SegmentAbstraction {
  constructor(private readonly analytics: AnalyticsBrowser) {}
  get segmentInstance() {
    return this.analytics;
  }
  public async page(...args: Parameters<AnalyticsBrowser['page']>) {
    this.analytics.page(...args);
  }
  public async track(...args: Parameters<AnalyticsBrowser['track']>) {
    this.analytics.track(...args);
  }
  public async identify(...args: Parameters<AnalyticsBrowser['identify']>) {
    this.analytics.identify(...args);
  }
}

export class SegmentMock implements SegmentAbstraction {
  public async page(...args: Parameters<AnalyticsBrowser['page']>) {
    console.log('ANALYTICS PAGE_VIEW', ...args);
  }
  public async track(...args: Parameters<AnalyticsBrowser['track']>) {
    console.log('ANALYTICS TRACK', ...args);
  }
  public async identify(...args: Parameters<AnalyticsBrowser['identify']>) {
    console.log('ANALYTICS IDENTIFY', ...args);
  }
}
